import { render, staticRenderFns } from "./myselfBody.vue?vue&type=template&id=8c22d614&scoped=true&"
import script from "./myselfBody.vue?vue&type=script&lang=js&"
export * from "./myselfBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c22d614",
  null
  
)

export default component.exports